<!-- CARD ESCRITORIO -->
<div class="my-4 d-none d-md-block" (click)="navigateToDetails()" style="cursor: pointer;">
  <div class="general-div">
    <div class="row card card-with-original-style">
      <div class="card-content-wrapper">
        <div class="bg-image-card">
          <img [src]="image" alt="Imagen relacionada con la noticia" class="img-fluid"
          (error)="image = './assets/home/image-error.png'"
          />
        </div>

        <div class="card-body card-body-with-original-style">
          <div
            class="oxy-post-category tag-pill desktop-category unskew d-none d-md-block"
            [ngStyle]="{
              'background-color': categoryBackgroundColor,
              'color': categoryFontColor
            }"
          >
            <p>{{category}}</p>
          </div>

          <div class="row desktop-only-row">
            <div class="col-md-6"></div>
              <div class="col-md-6 d-none d-md-block text-end unskew" (click)="$event.stopPropagation()">
               <app-reactions [reactions]="reactions"></app-reactions>
              </div>
          </div>

          <h4 class="app-bold-text unskew title-2-line-fixed mt-1">{{title}}</h4>
          <h6 class="text-muted fw-bold d-none d-md-block unskew">
            {{date | date: 'dd/MM/yyyy'}}
          </h6>

          <div
          class="oxy-post-excerpt unskew"
          style="text-overflow: ellipsis"
        >{{textContent}}</div>


          <div class="row mt-3 unskew">
            <div class="col-md-6">
              <div class="oxy-read-more">
                Leer más
                <img src="../../../../../../../../assets/buttons/go_icon.svg" alt="Ir" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="oxy-post-footer-container__right">
                 <img src="./../../../../../../assets/icons/clock.svg" alt="My icon" width="20" height="20" />
                <span class="text-muted fw-bold ms-2">{{readingTime}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- CARD MÓVIL -->
<div class="row card-mobile-row d-flex d-md-none" (click)="navigateToDetails()" style="cursor: pointer;">
  <div class="row col-6 pe-0" style="transform: none !important">
    <div class="card-mobile-image-wrapper position-relative" >
      <img [src]="image" alt="Imagen relacionada con la noticia"   (error)="image = './assets/home/image-error.png'" />

      <div
        class="oxy-post-category tag-pill category-on-mobile-image"
        [ngStyle]="{
          'background-color': categoryBackgroundColor,
          'color': categoryFontColor
        }"
      >
        {{category}}
      </div>
    </div>
  </div>

  <div class="col-6 ps-0 card-mobile-text-col mt-2 ms-3">
    <div class="position-relative">
      <div (click)="$event.stopPropagation()">
         <app-reactions [reactions]="reactions" ></app-reactions>

      </div>

      <h4 class="app-bold-text mt-1">{{title}}</h4>


      <div class="card-mobile-read-more" >
        Leer más
        <img src="../../../../../../../../assets/buttons/go_icon.svg" alt="Ir" />
      </div>
    </div>
  </div>
</div>
